import { useCallback, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Icon from '@web-ui-kit/icon'
import Tooltip from '@web-ui-kit/tooltip'
import * as Sc from './NavigationItem.style'

const NavigationItem = ({ icon, id, menu }) => {
  const buttonRef = useRef(null)
  const [closed, setClosed] = useState(false)
  const [actived, setActived] = useState(false)

  const handleCloseMenuListener = useCallback((event) => {
    if (
      (event.target.matches('button, button *') ||
        event.target.matches('a, a *')) &&
      !buttonRef.current?.contains(event.target)
    ) {
      setClosed(true)
    }
  }, [])

  const handleOnClickItem = () => {
    if (menu) return
    if (icon.onClick) return icon.onClick()
  }

  const handleOnChange = (isOpen) => {
    if (isOpen) {
      window.addEventListener('click', handleCloseMenuListener)
    }
    if (!isOpen) {
      window.removeEventListener('click', handleCloseMenuListener)
    }
    setClosed(!isOpen)
    setActived(isOpen)
  }

  const renderItem = () => {
    return (
      <Sc.StyledButtonIcon
        $isCustomElement={typeof icon.element !== 'string'}
        active={actived}
        dataTestId={id}
        disabled={icon.disabled}
        icon={
          typeof icon.element === 'string' ? (
            <Sc.ButtonIconContainer>
              <Icon icon={icon.element} />
              {Boolean(icon.badgeNumber) && (
                <Sc.ButtonIconBadge key={icon.badgeNumber}>
                  <Sc.BadgeText bold variant={'superSmall'}>
                    {icon.badgeNumber}
                  </Sc.BadgeText>
                </Sc.ButtonIconBadge>
              )}
            </Sc.ButtonIconContainer>
          ) : (
            <Sc.CustomElement $active={actived}>
              {icon.element}
            </Sc.CustomElement>
          )
        }
        onClick={handleOnClickItem}
        reference={buttonRef}
      />
    )
  }

  return menu ? (
    <Tooltip
      align='start'
      element={renderItem()}
      fixed
      forceClosed={closed}
      id={id}
      isResizable
      onChange={handleOnChange}
      selectableElement
    >
      <Sc.CustomMenuContainer>{menu}</Sc.CustomMenuContainer>
    </Tooltip>
  ) : (
    renderItem()
  )
}

NavigationItem.defaultProps = {
  menu: null,
}
NavigationItem.propTypes = {
  icon: PropTypes.shape({
    badgeNumber: PropTypes.number,
    disabled: PropTypes.bool,
    element: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    onClick: PropTypes.func,
  }).isRequired,
  id: PropTypes.string.isRequired,
  menu: PropTypes.node,
}

export default NavigationItem
